import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  zones: [],
  activityZoneListData: null,
  activityZoneListPagination: {
    perPage: 10,
    pageNum: 1,
  },
  savedThresholdSettings: {},
  selectedZone: {},
  signalStrengths: [],
}
export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}
